import _ from 'lodash';
import EmptyDataMessage from './EmptyDataMessage.component';
import { departmentColors } from '../../../module/yachtDashboard/conf/Data.conf';
import { Box } from '@mui/material';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { DetailConf } from '../../../module/yachtDashboard/conf/overview/Detail.conf';
import { DashboardDetail } from '../../detail/DashboardDetail';

const OverviewTabContent = ({ operations }) => {
  const { fields, formatValue } = DetailConf;
  const navigate = useNavigate();
  const handleCardClick = useCallback(
    (departmentName, idOperation) => {
      navigate(`/department/${departmentName.toLowerCase()}/${idOperation}`);
    },
    [navigate]
  );

  return (
    <Box sx={{ minHeight: '55vh' }}>
      {!_.isEmpty(operations) ? (
        operations.map((operation) => {
          const departmentName =
            operation.attributes?.id_department?.data?.attributes
              ?.name_department || '';
          const departmentColor = departmentName
            ? departmentColors?.[departmentName]
            : departmentColors?.DEFAULT;
          const colorTab = departmentColor || departmentColors?.DEFAULT_TAB;

          const data = {
            ...operation,
            attributes: {
              ...operation?.attributes,
              OC_BC_number: operation?.attributes?.OC_BC_number || '-',
              OF_BF_number: operation?.attributes?.OF_BF_number || '-',
              operation_service:
                operation?.attributes?.operation_service || '-',
            },
          };

          return (
            <DashboardDetail
              key={operation.id}
              fields={fields}
              data={data}
              render={formatValue}
              colorTab={colorTab}
              hasHeader
              departmentColor={departmentColor}
              departmentName={departmentName}
              onClick={() => handleCardClick(departmentName, operation.id)}
            />
          );
        })
      ) : (
        <EmptyDataMessage message='No operations found' />
      )}
    </Box>
  );
};

export default OverviewTabContent;
